import { useEffect, useState } from "react";
import LoadingOverlay from "../../../components/LoadingOverlay";
import { T2 } from "../../../styles/titles";
import {
  FormValues,
  SettlementsTableData,
  TotalsData
} from "./types";
import { Container } from "./styles";
import { FormFilter } from "./components/filter/filter";
import { Totals } from "./components/totals/totals";
import { LiveTable } from "./components/liveTable/liveTable";
import { Button } from "../../terminaisPhoebus/styles";
import PaymentsService from "./service/paymentsService";
import { can, PortalPermissions } from "../../../config/permissions";

const DetalhamentoPagamentosSLC: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState<SettlementsTableData | null>(null);
  const [totalsData, setTotalsData] = useState<TotalsData | null>(null);
  const [pageSize, setPageSize] = useState<number>(20);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [filterData, setFilterData] = useState<any>(null);
  const paymentsService = new PaymentsService();

  useEffect(() => {
    if (filterData) {
      setCurrentPage(1);
    }
  }, [filterData]);

  useEffect(() => {
    if (filterData) {
      fetchData();
    }
  }, [filterData, currentPage, pageSize]);

  const fetchData = async () => {
    setIsLoading(true);

    try {
      const data = await paymentsService.getPayments(
        currentPage,
        pageSize,
        filterData
      );

      setTotalsData({
        totalValue: data.totalPaymentValue || 0,
        totalDiscountedValue: data.totalDiscountedValue || 0,
        totalRows: data.rowCount,
      });

      setTableData({
        records: data.items || [],
        count: data.rowCount || 0,
      });
    } catch (error) {
      console.log("Erro ao buscar os detalhes dos pagamentos slc", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownload = async (filter?: FormValues) => {
    setIsLoading(true)
    const response = await paymentsService.getPaymentsXlsxDownload(
      filter);

    if (response) {
      const objectUrl = window.URL.createObjectURL(response);
      const a = document.createElement('a');
      a.href = objectUrl;
      a.download = buildXlsxFileName(); // Nome do arquivo
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(objectUrl);
      document.body.removeChild(a);
    }
    setIsLoading(false)
  };

  const handleDownloadGrouped = async (filter?: FormValues) => {
    setIsLoading(true);
    try {
      const response = await paymentsService.getPaymentsGroupedXlsxDownload(filter);

      if (response) {
        const objectUrl = window.URL.createObjectURL(response);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = buildGroupedXlsxFileName();
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(objectUrl);
        document.body.removeChild(a);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const buildXlsxFileName = () => {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');

    return `Pagamentos-slc-${day}-${month}-${year}-${hours}-${minutes}.xlsx`;
  }

  const buildGroupedXlsxFileName = () => {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');

    return `detalhamento-slc-agrupado-${day}-${month}-${year}-${hours}-${minutes}.xlsx`;
  }

  return (
    <Container>
      <LoadingOverlay show={isLoading} relative />

      <T2>Detalhamento Pagamentos</T2>
      {totalsData && <Totals data={totalsData} isAdmin={filterData.isAdmin} />}
      <FormFilter getFilters={(data) => setFilterData(data)} />

      <div style={{ display: 'flex', gap: '12px', marginBottom: '25px' }}>
        {can(PortalPermissions.slc.pagamentos.exportar) && (
          <Button
            onClick={() => handleDownload(filterData)}
            style={{ width: '150px' }}
          >
            Download XLSX
          </Button>
        )}
        {can(PortalPermissions.slc.pagamentos.exportar) && (
          <Button
            onClick={() => handleDownloadGrouped(filterData)}
            style={{ width: '220px' }}
          >
            Download XLSX Agrupado
          </Button>
        )}
      </div>
      {tableData && (
        <LiveTable
          data={tableData}
          currentPage={currentPage}
          pageSize={pageSize}
          onPageChange={setCurrentPage}
          onPageSizeChange={setPageSize}
          isAdmin={filterData.isAdmin}
        />
      )}
    </Container>
  );
};

export default DetalhamentoPagamentosSLC;
